import React from 'react';
import * as ReactRouterDOM from 'react-router-dom';
import { RevealOnScroll } from './effects/RevealOnScroll';
import { GlassCard } from './ui/GlassCard';
import { AnimatedGrid } from './effects/AnimatedGrid';
import { LeadFormModal } from './LeadFormModal';
import { Wrench, Rocket } from 'lucide-react';

interface WhatNextSectionProps {
    diyLink?: string;
    productSlug?: string;   // BBK SKU slug; falls back to 'general'
    ctaLabel?: string;
}

export const WhatNextSection: React.FC<WhatNextSectionProps> = ({ diyLink, productSlug, ctaLabel }) => {
    return (
        <section className="py-16 relative overflow-hidden">
            <div className="container mx-auto px-4 max-w-4xl relative z-10">
                <RevealOnScroll>
                    <GlassCard variant="strong" className="relative overflow-hidden text-center">
                        <AnimatedGrid variant="dots" animated={false} />
                        <div className="relative z-10">
                            <h2 className="text-3xl font-bold mb-4 text-text-primary-light dark:text-text-primary-dark">
                                Co dalej?
                            </h2>
                            <p className="text-lg text-text-secondary-light dark:text-text-secondary-dark mb-8">
                                Wybierz swoją ścieżkę do automatyzacji.
                            </p>
                            <div className="flex flex-col sm:flex-row justify-center gap-4 items-center">
                                <ReactRouterDOM.Link
                                    to={diyLink || '/#services'}
                                    className={`
                                        px-6 py-3 font-semibold rounded-xl
                                        text-primary-light dark:text-primary-dark
                                        bg-white/10 dark:bg-white/5 backdrop-blur-sm
                                        border border-white/20 dark:border-white/10
                                        hover:bg-white/20 dark:hover:bg-white/10
                                        hover:scale-[1.02]
                                        transition-all duration-300
                                        inline-flex items-center justify-center gap-2
                                    `}
                                >
                                    <Wrench className="w-5 h-5" />
                                    Spróbuj sam (DIY)
                                </ReactRouterDOM.Link>
                                <LeadFormModal
                                    productSlug={productSlug || 'general'}
                                    triggerLabel={ctaLabel || 'Umów rozmowę'}
                                    triggerClassName={`
                                        px-6 py-3 font-semibold rounded-xl text-white
                                        bg-gradient-to-r from-primary-light to-secondary-light
                                        dark:from-primary-dark dark:to-secondary-dark
                                        hover:shadow-xl hover:shadow-primary-light/30 dark:hover:shadow-primary-dark/30
                                        hover:scale-[1.02]
                                        transition-all duration-300
                                        inline-flex items-center justify-center gap-2 group
                                        animate-glow
                                    `}
                                />
                            </div>
                        </div>
                    </GlassCard>
                </RevealOnScroll>
            </div>
        </section>
    );
};
